import { SideNavItems, SideNavSection } from '@modules/navigation/models'
import { AccountRole, AccountProductType } from '@models/account.model'
import { UserRole } from '@models/user.model'

export const sideNavSections: SideNavSection[] = [
	{
		text: 'RECURSO',
		items: [
			{
				active: true,
				sideNavItemName: 'dashboard',
				products: [AccountProductType.PCA, AccountProductType.PDP, AccountProductType.PLA, AccountProductType.DIS, AccountProductType.GEN],
				roles: [
					AccountRole.ADMIN,
					AccountRole.OWNER,
					AccountRole.MEMBER,
					AccountRole.MANAGER,
					UserRole.SUPPORT_STAFF,
					AccountRole.SUPER_ADMIN,
					AccountRole.SUPPORT_STAFF,
					UserRole.SUPPORT_STAFF_READONLY,
					AccountRole.SUPPORT_STAFF_READONLY
				]
			},
			{
				active: true,
				sideNavItemName: 'pca',
				products: [AccountProductType.PCA],
				roles: [
					AccountRole.ADMIN,
					AccountRole.OWNER,
					AccountRole.MEMBER,
					AccountRole.MANAGER,
					UserRole.SUPPORT_STAFF,
					AccountRole.SUPER_ADMIN,
					AccountRole.SUPPORT_STAFF,
					UserRole.SUPPORT_STAFF_READONLY,
					AccountRole.SUPPORT_STAFF_READONLY
				]
			},
			{
				active: true,
				sideNavItemName: 'pla',
				products: [AccountProductType.PLA],
				roles: [
					AccountRole.ADMIN,
					AccountRole.OWNER,
					AccountRole.MEMBER,
					AccountRole.MANAGER,
					UserRole.SUPPORT_STAFF,
					AccountRole.SUPER_ADMIN,
					AccountRole.SUPPORT_STAFF,
					UserRole.SUPPORT_STAFF_READONLY,
					AccountRole.SUPPORT_STAFF_READONLY
				]
			},
			{
				active: true,
				sideNavItemName: 'ele',
				products: [AccountProductType.PLA],
				roles: [
					AccountRole.ADMIN,
					AccountRole.OWNER,
					AccountRole.MEMBER,
					AccountRole.MANAGER,
					UserRole.SUPPORT_STAFF,
					AccountRole.SUPER_ADMIN,
					AccountRole.SUPPORT_STAFF,
					UserRole.SUPPORT_STAFF_READONLY,
					AccountRole.SUPPORT_STAFF_READONLY
				]
			},
			{
				active: true,
				sideNavItemName: 'aux',
				products: [AccountProductType.PLA],
				roles: [
					AccountRole.ADMIN,
					AccountRole.OWNER,
					AccountRole.MEMBER,
					AccountRole.MANAGER,
					UserRole.SUPPORT_STAFF,
					AccountRole.SUPER_ADMIN,
					AccountRole.SUPPORT_STAFF,
					UserRole.SUPPORT_STAFF_READONLY,
					AccountRole.SUPPORT_STAFF_READONLY
				]
			},
			{
				active: true,
				sideNavItemName: 'dis',
				products: [AccountProductType.DIS, AccountProductType.PLA],
				roles: [
					AccountRole.ADMIN,
					AccountRole.OWNER,
					AccountRole.MEMBER,
					AccountRole.MANAGER,
					UserRole.SUPPORT_STAFF,
					AccountRole.SUPER_ADMIN,
					AccountRole.SUPPORT_STAFF,
					UserRole.SUPPORT_STAFF_READONLY,
					AccountRole.SUPPORT_STAFF_READONLY
				]
			},
			{
				active: true,
				sideNavItemName: 'pdp',
				products: [AccountProductType.PDP],
				roles: [
					AccountRole.ADMIN,
					AccountRole.OWNER,
					AccountRole.MEMBER,
					AccountRole.MANAGER,
					UserRole.SUPPORT_STAFF,
					AccountRole.SUPER_ADMIN,
					AccountRole.SUPPORT_STAFF,
					UserRole.SUPPORT_STAFF_READONLY,
					AccountRole.SUPPORT_STAFF_READONLY
				]
			},
			{
				active: true,
				sideNavItemName: 'gen',
				products: [AccountProductType.GEN],
				roles: [
					AccountRole.ADMIN,
					AccountRole.OWNER,
					AccountRole.MEMBER,
					AccountRole.MANAGER,
					UserRole.SUPPORT_STAFF,
					AccountRole.SUPER_ADMIN,
					AccountRole.SUPPORT_STAFF,
					UserRole.SUPPORT_STAFF_READONLY,
					AccountRole.SUPPORT_STAFF_READONLY
				]
			},
			{
				active: true,
				sideNavItemName: 'arp',
				products: [AccountProductType.GEN],
				roles: [
					AccountRole.ADMIN,
					AccountRole.OWNER,
					AccountRole.MEMBER,
					AccountRole.MANAGER,
					UserRole.SUPPORT_STAFF,
					AccountRole.SUPER_ADMIN,
					AccountRole.SUPPORT_STAFF,
					UserRole.SUPPORT_STAFF_READONLY,
					AccountRole.SUPPORT_STAFF_READONLY
				]
			},
			{
				active: true,
				sideNavItemName: 'notices',
				products: [AccountProductType.SUP],
				roles: [UserRole.SUPPLIER]
			},
			{
				active: true,
				sideNavItemName: 'enrollmentNotice',
				products: [AccountProductType.SUP],
				roles: [UserRole.SUPPLIER]
			},
			{
				active: true,
				sideNavItemName: 'sup',
				products: [AccountProductType.SUP],
				roles: [UserRole.SUPPLIER]
			},
			{
				active: true,
				sideNavItemName: 'sig',
				products: [AccountProductType.SIG],
				roles: [UserRole.SIGNER]
			},
			{
				active: true,
				sideNavItemName: 'visitorBoard',
				products: [AccountProductType.VIS],
				roles: [UserRole.VISITOR]
			},
			{
				active: true,
				sideNavItemName: 'visitorProfile',
				products: [AccountProductType.VIS],
				roles: [UserRole.VISITOR]
			}
		]
	},
	{
		text: 'CADASTRO',
		items: [
			{
				active: true,
				sideNavItemName: 'persons',
				products: [AccountProductType.PCA, AccountProductType.PLA, AccountProductType.DIS, AccountProductType.PDP, AccountProductType.GEN],
				roles: [
					AccountRole.ADMIN,
					AccountRole.OWNER,
					AccountRole.MEMBER,
					AccountRole.MANAGER,
					UserRole.SUPPORT_STAFF,
					AccountRole.SUPER_ADMIN,
					AccountRole.SUPPORT_STAFF,
					UserRole.SUPPORT_STAFF_READONLY,
					AccountRole.SUPPORT_STAFF_READONLY
				]
			},
			{
				active: true,
				sideNavItemName: 'responsibles',
				products: [AccountProductType.PCA, AccountProductType.PLA, AccountProductType.DIS, AccountProductType.PDP, AccountProductType.GEN],
				roles: [
					AccountRole.ADMIN,
					AccountRole.OWNER,
					AccountRole.MEMBER,
					AccountRole.MANAGER,
					UserRole.SUPPORT_STAFF,
					AccountRole.SUPER_ADMIN,
					AccountRole.SUPPORT_STAFF,
					UserRole.SUPPORT_STAFF_READONLY,
					AccountRole.SUPPORT_STAFF_READONLY
				]
			},
			{
				active: true,
				sideNavItemName: 'commissions',
				products: [AccountProductType.PLA, AccountProductType.DIS],
				roles: [
					AccountRole.ADMIN,
					AccountRole.OWNER,
					AccountRole.MEMBER,
					AccountRole.MANAGER,
					UserRole.SUPPORT_STAFF,
					AccountRole.SUPER_ADMIN,
					AccountRole.SUPPORT_STAFF,
					UserRole.SUPPORT_STAFF_READONLY,
					AccountRole.SUPPORT_STAFF_READONLY
				]
			},
			{
				active: true,
				sideNavItemName: 'managementUnits',
				products: [AccountProductType.PCA, AccountProductType.PLA, AccountProductType.DIS],
				roles: [
					AccountRole.ADMIN,
					AccountRole.OWNER,
					AccountRole.MEMBER,
					AccountRole.MANAGER,
					UserRole.SUPPORT_STAFF,
					AccountRole.SUPER_ADMIN,
					AccountRole.SUPPORT_STAFF,
					UserRole.SUPPORT_STAFF_READONLY,
					AccountRole.SUPPORT_STAFF_READONLY
				]
			},
			{
				active: true,
				sideNavItemName: 'publicAgencies',
				products: [AccountProductType.PCA, AccountProductType.PLA, AccountProductType.DIS],
				roles: [
					AccountRole.ADMIN,
					AccountRole.OWNER,
					AccountRole.MEMBER,
					AccountRole.MANAGER,
					UserRole.SUPPORT_STAFF,
					AccountRole.SUPER_ADMIN,
					AccountRole.SUPPORT_STAFF,
					UserRole.SUPPORT_STAFF_READONLY,
					AccountRole.SUPPORT_STAFF_READONLY
				]
			},
			{
				active: true,
				sideNavItemName: 'organizationalStructures',
				products: [AccountProductType.PCA, AccountProductType.PLA, AccountProductType.DIS],
				roles: [
					AccountRole.ADMIN,
					AccountRole.OWNER,
					AccountRole.MEMBER,
					AccountRole.MANAGER,
					UserRole.SUPPORT_STAFF,
					AccountRole.SUPER_ADMIN,
					AccountRole.SUPPORT_STAFF,
					UserRole.SUPPORT_STAFF_READONLY,
					AccountRole.SUPPORT_STAFF_READONLY
				]
			},
			{
				active: true,
				sideNavItemName: 'expenditureSubElements',
				products: [AccountProductType.PCA, AccountProductType.PLA],
				roles: [
					AccountRole.ADMIN,
					AccountRole.OWNER,
					AccountRole.MEMBER,
					AccountRole.MANAGER,
					UserRole.SUPPORT_STAFF,
					AccountRole.SUPER_ADMIN,
					AccountRole.SUPPORT_STAFF,
					UserRole.SUPPORT_STAFF_READONLY,
					AccountRole.SUPPORT_STAFF_READONLY
				]
			},
			{
				active: true,
				sideNavItemName: 'supplierCompany',
				products: [AccountProductType.SUP],
				roles: [UserRole.SUPPLIER]
			},
			{
				active: true,
				sideNavItemName: 'supplierResponsible',
				products: [AccountProductType.SUP],
				roles: [UserRole.SUPPLIER]
			},
			{
				active: true,
				sideNavItemName: 'signerResponsible',
				products: [AccountProductType.SIG],
				roles: [UserRole.SIGNER]
			},
			{
				active: true,
				sideNavItemName: 'supplierCatalog',
				products: [AccountProductType.SUP],
				roles: [UserRole.SUPPLIER]
			},
			{
				active: true,
				sideNavItemName: 'supplierValidation',
				products: [AccountProductType.SUP],
				roles: [UserRole.SUPPLIER]
			}
		]
	},
	{
		text: 'ACESSO',
		items: [
			{
				active: true,
				sideNavItemName: 'profile',
				products: [
					AccountProductType.PCA,
					AccountProductType.PLA,
					AccountProductType.PDP,
					AccountProductType.SUP,
					AccountProductType.DIS,
					AccountProductType.GEN,
					AccountProductType.SIG,
					AccountProductType.VIS
				],
				roles: [
					UserRole.SIGNER,
					UserRole.VISITOR,
					AccountRole.ADMIN,
					AccountRole.OWNER,
					UserRole.SUPPLIER,
					AccountRole.MEMBER,
					AccountRole.MANAGER,
					UserRole.SUPPORT_STAFF,
					AccountRole.SUPER_ADMIN,
					AccountRole.SUPPORT_STAFF
				]
			},
			{
				active: true,
				sideNavItemName: 'users',
				products: [AccountProductType.PCA, AccountProductType.PLA, AccountProductType.PDP, AccountProductType.DIS, AccountProductType.GEN],
				roles: [
					AccountRole.ADMIN,
					AccountRole.OWNER,
					UserRole.SUPPORT_STAFF,
					AccountRole.SUPER_ADMIN,
					AccountRole.SUPPORT_STAFF,
					AccountRole.SUPPORT_STAFF_READONLY
				]
			},
			{
				active: true,
				sideNavItemName: 'settings',
				products: [AccountProductType.PCA, AccountProductType.PLA, AccountProductType.PDP, AccountProductType.DIS, AccountProductType.GEN],
				roles: [
					AccountRole.ADMIN,
					AccountRole.OWNER,
					UserRole.SUPPORT_STAFF,
					AccountRole.SUPER_ADMIN,
					AccountRole.SUPPORT_STAFF,
					AccountRole.SUPPORT_STAFF_READONLY
				]
			}
		]
	},
	{
		text: 'SUPORTE',
		items: [
			{
				active: true,
				sideNavItemName: 'supportWhats',
				products: [
					AccountProductType.PCA,
					AccountProductType.PLA,
					AccountProductType.PDP,
					AccountProductType.SUP,
					AccountProductType.DIS,
					AccountProductType.GEN,
					AccountProductType.SIG,
					AccountProductType.VIS
				],
				roles: [
					UserRole.SIGNER,
					UserRole.VISITOR,
					AccountRole.ADMIN,
					UserRole.SUPPLIER,
					AccountRole.MEMBER,
					AccountRole.MANAGER,
					UserRole.SUPPORT_STAFF,
					AccountRole.SUPER_ADMIN,
					AccountRole.SUPPORT_STAFF
				]
			},
			{
				active: true,
				sideNavItemName: 'supportEmail',
				products: [
					AccountProductType.PCA,
					AccountProductType.PLA,
					AccountProductType.PDP,
					AccountProductType.SUP,
					AccountProductType.DIS,
					AccountProductType.GEN,
					AccountProductType.SIG,
					AccountProductType.VIS
				],
				roles: [
					UserRole.SIGNER,
					UserRole.VISITOR,
					AccountRole.ADMIN,
					UserRole.SUPPLIER,
					AccountRole.MEMBER,
					AccountRole.MANAGER,
					UserRole.SUPPORT_STAFF,
					AccountRole.SUPER_ADMIN,
					AccountRole.SUPPORT_STAFF
				]
			},
			{
				active: true,
				sideNavItemName: 'supportHealthCheck',
				products: [
					AccountProductType.PCA,
					AccountProductType.PLA,
					AccountProductType.PDP,
					AccountProductType.SUP,
					AccountProductType.DIS,
					AccountProductType.GEN,
					AccountProductType.SIG
				],
				roles: [UserRole.SUPPORT_STAFF, UserRole.APP_ADMIN, UserRole.SUPPORT_STAFF_READONLY]
			}
		]
	}
]

export const sideNavItems: SideNavItems = {
	dashboard: {
		active: true,
		icon: 'activity',
		text: 'Dashboard',
		link: '/dashboard'
	},
	pca: {
		text: 'Plano de Contratação Anual',
		client: true,
		active: true,
		awesome: true,
		link: '/pca/board',
		icon: 'square-poll-vertical',
		products: [AccountProductType.PCA, AccountProductType.PLA]
	},
	pla: {
		text: 'Documento de Intenção de Demanda',
		client: true,
		active: true,
		awesome: true,
		link: '/planning/board',
		icon: 'chart-gantt',
		products: [AccountProductType.PLA]
	},
	ele: {
		text: 'Processos Eletrônico',
		client: true,
		active: true,
		awesome: true,
		link: '/planning/electronic-processes/board',
		icon: 'file-lines',
		products: [AccountProductType.PLA]
	},
	aux: {
		text: 'Publicação Avulsa',
		client: true,
		active: true,
		awesome: true,
		link: '/planning/auxiliary-publications/board',
		icon: 'file-export',
		products: [AccountProductType.PLA]
	},
	dis: {
		text: 'Procedimentos',
		client: true,
		active: true,
		awesome: true,
		icon: 'paperclip',
		products: [AccountProductType.DIS],
		submenu: [
			{
				client: true,
				active: true,
				text: 'Auxiliares',
				link: '/planning/auxiliary-procedures'
			},
			{
				client: true,
				active: true,
				text: 'Licitatórios',
				link: '/planning/bidding-procedures'
			}
		]
	},
	pdp: {
		text: 'Pesquisa de Preço',
		client: true,
		active: true,
		awesome: true,
		link: '/price-research/board',
		icon: 'magnifying-glass-dollar',
		products: [AccountProductType.PDP]
	},
	gen: {
		text: 'Contratos',
		client: true,
		active: true,
		awesome: true,
		link: '/contracts/board',
		icon: 'handshake',
		products: [AccountProductType.GEN]
	},
	arp: {
		text: 'ARP',
		client: true,
		active: true,
		awesome: true,
		link: '/involving-registration-prices/board',
		icon: 'file-invoice-dollar',
		products: [AccountProductType.GEN]
	},
	notices: {
		active: true,
		icon: 'activity',
		text: 'Processos',
		link: '/supplier/board',
		products: [AccountProductType.SUP]
	},
	enrollmentNotice: {
		active: true,
		awesome: true,
		icon: 'paperclip',
		text: 'Meus Processos',
		link: '/supplier/processes',
		products: [AccountProductType.SUP]
	},
	sup: {
		active: true,
		awesome: true,
		icon: 'magnifying-glass-dollar',
		text: 'Minhas Pesquisas',
		link: '/supplier/researchers',
		products: [AccountProductType.SUP]
	},
	sig: {
		active: true,
		awesome: true,
		icon: 'file-signature',
		text: 'Assinaturas',
		link: '/signer/board',
		products: [AccountProductType.SIG]
	},
	// Área do visitante (spec 048).
	visitorBoard: {
		active: true,
		icon: 'activity',
		text: 'Processos',
		link: '/visitor/board',
		products: [AccountProductType.VIS]
	},
	visitorProfile: {
		active: true,
		awesome: true,
		icon: 'id-card',
		text: 'Meus dados',
		link: '/visitor/profile',
		products: [AccountProductType.VIS]
	},
	persons: {
		text: 'Pessoa',
		icon: 'people-line',
		awesome: true,
		client: true,
		active: true,
		submenu: [
			{
				active: true,
				text: 'Meus cadastrados',
				link: '/persons/search'
			},
			{
				active: true,
				text: 'Cadastrar',
				link: '/persons/register',
				roles: [
					AccountRole.ADMIN,
					AccountRole.OWNER,
					AccountRole.MANAGER,
					UserRole.SUPPORT_STAFF,
					AccountRole.SUPER_ADMIN,
					AccountRole.SUPPORT_STAFF,
					UserRole.SUPPORT_STAFF_READONLY,
					AccountRole.SUPPORT_STAFF_READONLY
				]
			},
			{
				text: 'Cargos',
				active: true,
				submenu: [
					{
						active: true,
						text: 'Meus cargos',
						link: '/responsibilities/search'
					},
					{
						active: true,
						text: 'Cadastrar',
						link: '/responsibilities/register',
						roles: [
							AccountRole.ADMIN,
							AccountRole.OWNER,
							AccountRole.MANAGER,
							UserRole.SUPPORT_STAFF,
							AccountRole.SUPER_ADMIN,
							AccountRole.SUPPORT_STAFF,
							UserRole.SUPPORT_STAFF_READONLY,
							AccountRole.SUPPORT_STAFF_READONLY
						]
					}
				]
			}
		]
	},
	commissions: {
		text: 'Comissões',
		icon: 'users-between-lines',
		awesome: true,
		active: true,
		client: true,
		submenu: [
			{
				active: true,
				text: 'Minhas comissões',
				link: '/commissions/search'
			},
			{
				active: true,
				text: 'Cadastrar',
				link: '/commissions/register',
				roles: [
					AccountRole.ADMIN,
					AccountRole.OWNER,
					AccountRole.MEMBER,
					UserRole.APP_MEMBER,
					AccountRole.MANAGER,
					UserRole.SUPPORT_STAFF,
					AccountRole.SUPER_ADMIN,
					AccountRole.SUPPORT_STAFF,
					UserRole.SUPPORT_STAFF_READONLY,
					AccountRole.SUPPORT_STAFF_READONLY
				]
			}
		]
	},
	responsibles: {
		text: 'Responsável',
		icon: 'user-group',
		awesome: true,
		client: true,
		active: true,
		products: [AccountProductType.PDP, AccountProductType.PLA, AccountProductType.PCA, AccountProductType.DIS, AccountProductType.GEN],
		submenu: [
			{
				active: true,
				text: 'Meus responsaveis',
				link: '/responsibles/search'
			},
			{
				active: true,
				text: 'Cadastrar',
				link: '/responsibles/register',
				roles: [
					AccountRole.ADMIN,
					AccountRole.OWNER,
					AccountRole.MANAGER,
					UserRole.SUPPORT_STAFF,
					AccountRole.SUPER_ADMIN,
					AccountRole.SUPPORT_STAFF,
					UserRole.SUPPORT_STAFF_READONLY,
					AccountRole.SUPPORT_STAFF_READONLY
				]
			}
		]
	},
	publicAgencies: {
		text: 'Unidade Gestora',
		icon: 'landmark',
		awesome: true,
		active: true,
		client: true,
		submenu: [
			{
				active: true,
				text: 'Minhas unidades',
				link: '/public-agencies/search'
			},
			{
				active: true,
				text: 'Cadastrar',
				link: '/public-agencies/register',
				roles: [
					AccountRole.ADMIN,
					AccountRole.OWNER,
					AccountRole.MANAGER,
					UserRole.SUPPORT_STAFF,
					AccountRole.SUPER_ADMIN,
					AccountRole.SUPPORT_STAFF,
					UserRole.SUPPORT_STAFF_READONLY,
					AccountRole.SUPPORT_STAFF_READONLY
				]
			}
		]
	},
	managementUnits: {
		text: 'Unidade Orçamentária',
		icon: 'people-roof',
		awesome: true,
		active: true,
		client: true,
		submenu: [
			{
				active: true,
				text: 'Minhas unidades',
				link: '/management-units/search'
			},
			{
				active: true,
				text: 'Cadastrar',
				link: '/management-units/register',
				roles: [
					AccountRole.ADMIN,
					AccountRole.OWNER,
					AccountRole.MANAGER,
					UserRole.SUPPORT_STAFF,
					AccountRole.SUPER_ADMIN,
					AccountRole.SUPPORT_STAFF,
					UserRole.SUPPORT_STAFF_READONLY,
					AccountRole.SUPPORT_STAFF_READONLY
				]
			}
		]
	},
	organizationalStructures: {
		text: 'Estruturas Organizacional',
		icon: 'sitemap',
		awesome: true,
		active: true,
		client: true,
		submenu: [
			{
				active: true,
				text: 'Estruturas',
				link: '/organizational-structures/search'
			},
			{
				active: true,
				text: 'Cadastrar',
				link: '/organizational-structures/register',
				roles: [
					AccountRole.ADMIN,
					AccountRole.OWNER,
					AccountRole.MANAGER,
					UserRole.SUPPORT_STAFF,
					AccountRole.SUPER_ADMIN,
					AccountRole.SUPPORT_STAFF,
					UserRole.SUPPORT_STAFF_READONLY,
					AccountRole.SUPPORT_STAFF_READONLY
				]
			}
		]
	},
	expenditureSubElements: {
		text: 'Sub-elemento de Despesa',
		icon: 'list-check',
		awesome: true,
		active: true,
		client: true,
		submenu: [
			{
				active: true,
				text: 'Todos',
				link: '/expenditure-sub-elements/search'
			},
			{
				active: true,
				text: 'Cadastrar',
				link: '/expenditure-sub-elements/register',
				roles: [
					AccountRole.ADMIN,
					AccountRole.OWNER,
					AccountRole.MANAGER,
					UserRole.SUPPORT_STAFF,
					AccountRole.SUPER_ADMIN,
					AccountRole.SUPPORT_STAFF,
					UserRole.SUPPORT_STAFF_READONLY,
					AccountRole.SUPPORT_STAFF_READONLY
				]
			}
		]
	},
	supplierCompany: {
		text: 'Fornecedor',
		icon: 'handshake',
		awesome: true,
		active: true,
		link: '/supplier/company'
	},
	supplierResponsible: {
		text: 'Responsáveis',
		icon: 'building-user',
		awesome: true,
		active: true,
		corporateSupplierOnly: true,
		link: '/supplier/responsible'
	},
	// Validação documental do fornecedor (spec 049): o menu não muda para o pendente, só ganha o caminho de volta à etapa.
	supplierValidation: {
		text: 'Validação do cadastro',
		icon: 'shield-halved',
		awesome: true,
		active: true,
		link: '/supplier/validation'
	},
	signerResponsible: {
		text: 'Responsável',
		icon: 'building-user',
		awesome: true,
		active: true,
		link: '/signer/responsible'
	},
	supplierCatalog: {
		text: 'Meu Catálogo',
		icon: 'rectangle-list',
		awesome: true,
		active: true,
		submenu: [
			{
				active: true,
				text: 'Itens',
				link: '/supplier/catalog'
			}
		]
	},
	profile: {
		text: 'Minha conta',
		icon: 'user-gear',
		awesome: true,
		active: true,
		submenu: [
			{
				active: true,
				text: 'Perfil',
				link: '/account/profile/detail'
			},
			{
				active: true,
				text: 'Segurança',
				link: '/account/profile/security'
			}
		]
	},
	users: {
		text: 'Usuários',
		icon: 'users',
		awesome: true,
		active: true,
		client: true,
		submenu: [
			{
				active: true,
				text: 'Meus usuários',
				link: '/users/search'
			},
			{
				active: true,
				text: 'Cadastrar',
				link: '/users/register'
			}
		]
	},
	settings: {
		text: 'Configurações',
		icon: 'cogs',
		awesome: true,
		active: true,
		client: true,
		link: '/settings/organization'
	},
	supportWhats: {
		text: 'WhatsApp',
		icon: ['fab', 'square-whatsapp'],
		awesome: true,
		active: true,
		client: false,
		external: true,
		link: 'https://wa.me/558581647550'
	},
	supportEmail: {
		text: 'E-mail',
		icon: 'envelope',
		awesome: true,
		active: true,
		client: false,
		external: true,
		link: 'mailto:contato@silgov.com.br'
	},
	supportHealthCheck: {
		text: 'Health Check',
		icon: 'heart-pulse',
		awesome: true,
		active: true,
		client: false,
		link: '/support/health-check'
	}
}
